export const TOOLTIP_DISPLAY_NAME = "Tooltip";
